import React from "react";
import { useLang } from "@/contexts/LanguageContext";

const WORDS_ES = [
  "Diseño de sonrisa",
  "Carillas e.max",
  "Implantes",
  "Invisalign",
  "Blanqueamiento",
  "Rehabilitación oral",
  "Ortodoncia estética",
  "Tecnología 3D",
];
const WORDS_EN = [
  "Smile design",
  "e.max veneers",
  "Implants",
  "Invisalign",
  "Whitening",
  "Oral rehab",
  "Aesthetic ortho",
  "3D technology",
];

/**
 * Editorial slow marquee — scrolls at ~40s. Oversized display type with
 * delicate gold diamond separators. Pure CSS keyframes for performance.
 */
export const Marquee = () => {
  const { lang } = useLang();
  const words = lang === "es" ? WORDS_ES : WORDS_EN;
  // Duplicate the sequence twice so the translate(-50%) loop is seamless
  const sequence = [...words, ...words];

  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="relative bg-white py-10 md:py-14 border-y border-[#E5E5E5] overflow-hidden"
    >
      <div className="flex marquee-track whitespace-nowrap items-center">
        {sequence.map((w, i) => (
          <span
            key={i}
            className="flex items-center shrink-0 pr-10 md:pr-16"
          >
            <span className="font-display font-light italic text-[#1A1A1A] text-5xl md:text-7xl lg:text-8xl tracking-[-0.02em] leading-none">
              {w}
            </span>
            <span className="inline-block w-2 h-2 rotate-45 bg-[#D4AF37] ml-10 md:ml-16" />
          </span>
        ))}
      </div>
    </section>
  );
};
